import { Component, inject, Input, OnInit } from '@angular/core'

import { IonicModule, PopoverController } from '@ionic/angular'
import { Announcement } from '../../../models/announcement'
import { AnnouncementsService } from '../../../services/domain/announcements/announcements.service'
import { UsersService } from '../../../services/domain/users.service'
import { User } from '@ionic/cli'
import { takeUntil } from 'rxjs/operators'
import { Subject } from 'rxjs'

@Component({
  selector: 'app-announcement-item-popover-menu',
  standalone: true,
  imports: [IonicModule],
  templateUrl: './announcement-item-popover-menu.component.html',
  styleUrls: ['./announcement-item-popover-menu.component.scss'],
})
export class AnnouncementItemPopoverMenuComponent implements OnInit {
  private announcementsService = inject(AnnouncementsService)
  private popoverCtrl = inject(PopoverController)
  private usersService = inject(UsersService)

  @Input() announcement: Announcement
  @Input() canEdit: boolean = false
  unsubscribe = new Subject<void>()
  currentUser: User

  ngOnInit(): void {
    this.usersService
      .getCurrentUser()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((currentUser) => (this.currentUser = currentUser))
  }
  async setRead(a: Announcement, event?) {
    // event?.stopPropagation()
    await this.announcementsService.markMessageRead(a)
    this.popoverCtrl.dismiss()
  }
  edit() {
    this.popoverCtrl.dismiss(null, 'edit')
  }
  delete() {
    this.popoverCtrl.dismiss(null, 'delete')
  }
  isPublished() {
    return !!this.announcement.publishedAt
  }
  archive() {
    this.popoverCtrl.dismiss(null, 'archive')
  }
  publish() {
    this.popoverCtrl.dismiss(null, 'publish')
  }

  async setUnread(a: Announcement) {
    await this.announcementsService.markMessageUnread(a)
    this.popoverCtrl.dismiss()
  }
}
